
  export default {
    props: ['error']
  }
